import React from 'react';

const navigator = (e, url) => {
    e.preventDefault();
    window.parent.postMessage({ eventName: 'navigateMessage', value: url }, '*');
};

export default ({ action, domain }) => {
    return (
        <a
            onClick={(e) => {
                navigator(e, `${domain}${action.uri}`);
            }}
            href={`#`}
        >
            {action.label}
        </a>
    );
};
